import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj)
    } catch (_) {
      return null
    }
  }
  constructor({user_id, firstname, lastname, email, exp}) {
    this.id = user_id
    this.firstname = firstname
    this.lastname = lastname
    this.email = email
    this.exp = exp
  }
}





// WEBPACK FOOTER //
// ./src/models/User.js